// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"182":"82a1feb7","189":"937c36d0"}[chunkId] + ".js";
};